<template>
  <form name="pay"
        method="post"
        content="application/json">
    <input type="hidden" name="payMethod" value="BANK">
    <input type="hidden" name="goodsNm" :value="goodsNm">
    <input type="hidden" name="ordNo" :value="ordNo">
    <input type="hidden" name="goodsAmt" :value="goodsAmt">
    <input type="hidden" name="ordNm" :value="ordNm">
    <input type="hidden" name="ordTel" :value="ordTel">
    <input type="hidden" name="ordEmail" :value="ordEmail">
    <input type="hidden" name="mbsUsrId" :value="mbsUsrId">
    <input type="hidden" name="returnUrl" :value="returnUrl">
  </form>
  <teleport to="body">
    <iframe v-if="isShow"
            style="width: 100%; height: 100%; z-index: 9999 !important; display: block; overflow: hidden; position: absolute; top: 0;"
            name="popupPay"></iframe>
  </teleport>
</template>

<script setup>
import {defineExpose, defineEmits, nextTick, onMounted, ref} from "vue";

const emits = defineEmits(['pay', 'syserr']);

const goodsNm = ref('');
const ordNo = ref('');
const goodsAmt = ref('');
const ordNm = ref('');
const ordTel = ref('');
const returnUrl = ref('');
const ordEmail = ref('');
const mbsUsrId = ref('');

const isShow = ref(false);

const show = (params) => {
  setPayParams(params);

  isShow.value = true;
  nextTick(() => {
    document.pay.action = "/onpay/p1/std/v1/payform";
    document.pay.target = "popupPay";

    window.addEventListener('message', payResultMessageListner);

    document.pay.submit();
  });
}

const payResultMessageListner = async (event) => {
  isShow.value = false;
  clearParams();
  const data = event.data;
  const { type, params } = data;
  
  if (type == 'finish') {
    const result = JSON.parse(params);
    const payParams = {
      resultCd: result.resultCd,
      resultMsg: result.resultMsg,
      amt: result.amt,
      tid: result.tid
    };
    emits('pay', payParams);
  } else if (type != 'cancel') {
    emits('syserr');
  }
};

const setPayParams = (params) => {
  goodsNm.value = String(params.goodsNm);
  ordNo.value = String(params.ordNo);
  goodsAmt.value = String(params.goodsAmt);
  ordNm.value = String(params.ordNm);
  ordTel.value = String(params.ordTel).replace(/[^0-9]/g, '');
  ordEmail.value = String(params.ordEmail);
  mbsUsrId.value = String(params.mbsUsrId);
  const {host, protocol} = window.location;
  returnUrl.value = `${protocol}//${host}`;
};

const clearParams = () => {
  goodsNm.value = '';
  ordNo.value = '';
  goodsAmt.value = '';
  ordNm.value = '';
  ordTel.value = '';
  ordEmail.value = '';
  mbsUsrId.value = '';
};

defineExpose({
  show
});

onMounted(() => {
})
</script>

<style scoped>

</style>
